import { useState } from "react";

type Props = {
  text: string;
};

export function InfoTooltip({ text }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <span className="info-tooltip">
      <button
        type="button"
        className="info-tooltip__trigger"
        aria-label="More info"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        onBlur={() => setOpen(false)}
      >
        i
      </button>
      <span
        className={`info-tooltip__bubble${open ? " info-tooltip__bubble--open" : ""}`}
        role="tooltip"
      >
        {text}
      </span>
    </span>
  );
}
